import React, { useState, useEffect } from 'react';
import { usersAPI, devicesAPI } from '../services/api';

function Dashboard() {
  const [stats, setStats] = useState({
    totalUsers: 0,
    activeUsers: 0,
    totalDevices: 0,
    activeDevices: 0,
  });
  const [loading, setLoading] = useState(true);
  const [loadingTime, setLoadingTime] = useState(0);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    const startTime = Date.now();
    setLoading(true);
    
    try {
      const [usersRes, devicesRes] = await Promise.all([
        usersAPI.getUsers({ limit: 1 }).catch(() => ({ data: { total: 0 } })),
        devicesAPI.getDevices({ limit: 1 }).catch(() => ({ data: { total: 0 } })),
      ]);

      setStats({
        totalUsers: usersRes.data?.total || 0,
        activeUsers: usersRes.data?.total || 0,
        totalDevices: devicesRes.data?.total || 0,
        activeDevices: devicesRes.data?.total || 0,
      });
      
      const elapsed = Date.now() - startTime;
      setLoadingTime(elapsed);
    } catch (error) {
      console.error('Error fetching stats:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        Loading dashboard... (connecting to Seoul AWS)
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1>Dashboard</h1>
        <p>Overview of your Puraxel backoffice</p>
        {loadingTime > 0 && (
          <p style={{ fontSize: '12px', color: '#95a5a6' }}>
            Loaded in {loadingTime}ms {loadingTime > 1000 && '(cached data will be faster)'}
          </p>
        )}
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <h3>Total Users</h3>
          <div className="value">{stats.totalUsers.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <h3>Active Users</h3>
          <div className="value">{stats.activeUsers.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <h3>Total Devices</h3>
          <div className="value">{stats.totalDevices.toLocaleString()}</div>
        </div>
        <div className="stat-card">
          <h3>Active Devices</h3>
          <div className="value">{stats.activeDevices.toLocaleString()}</div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <h2>Quick Actions</h2>
        </div>
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button className="btn btn-primary" onClick={() => window.location.href = '/users'}>
            Manage Users
          </button>
          <button className="btn btn-primary" onClick={() => window.location.href = '/devices'}>
            Manage Devices
          </button>
          <button className="btn btn-success" onClick={() => window.location.href = '/notifications'}>
            Send Notification
          </button>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;